import React from 'react'

function GoogleMap() {
    return (
        <div>
        <div className="album py-2">
                <div className="container">
                    <div className="row">
                    <iframe className="iframe-fluid mb-2" height="400" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" id="gmap_canvas" src="https://maps.google.com/maps?width=520&amp;height=400&amp;hl=en&amp;q=SRG%20Complex,%20CG6F+X9R,%20Chadmari,%20Krishnanagar,%20West%20Bengal%20741103%20+(SRG%20Complex,%20CG6F+X9R,%20Chadmari,%20Krishnanagar,%20West%20Bengal%20741103)&amp;t=&amp;z=12&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe>
                </div>
            </div>
            </div>
        </div>
    )
}

export default GoogleMap